import JSONLDAbstractNode from 'react-structured-data/dist/JSONLDAbstractNode';

const typeKey = '@type';

const checkIfChildAllowed = (fields, filteredSchema, child) => {
  if (Object.keys(child).includes(typeKey)) {
    const childType = child[typeKey];
    return childType && fields.includes(childType);
  }

  if (Object.keys(child).length !== 1) {
    return false;
  }

  const childType = Object.keys(child)[0];
  return fields.includes(childType);
};

class CustomizableGeneric extends JSONLDAbstractNode {
  getJSON(isFirstChildNode = false, schema) {
    const parsedChildren = super.parseChildren();

    const fields = this.getFields ? this.getFields() : [];
    const filteredSchema = {};
    fields.forEach(field => {
      if (schema[field]) {
        filteredSchema[field] = schema[field];
      }
    });
    const details = {
      [typeKey]: this.getTypeName(),
      ...filteredSchema
    };

    if (!fields || !Array.isArray(parsedChildren)) {
      return Object.assign(details);
    }

    const allowedChildren = parsedChildren.filter(child => checkIfChildAllowed(fields, filteredSchema, child));
    return Object.assign(details, ...allowedChildren);
  }
}

export default CustomizableGeneric;
